import config from '../config';
import http from '../utils/http';
import { News } from '../interface/common.interface';

const { api } = config;

/**
 * Get all news.
 */

export const fetchNews = async (): Promise<News[]> => {
    const url = api.endpoints.news;
    const response = await http.get(url);
    return response.data;
};
